export default () => {
  const containers = document.querySelectorAll('.js-faq-toggle')
  if (! containers.length > 0 ) return
  
  ;[...containers].forEach((container) => {
    const trigger = container.querySelector('.js-faq-toggle-trigger')
    const panel = container.querySelector('.js-faq-toggle-panel')

    trigger.addEventListener('click', (e) => {
      if (container.classList.contains('active')) {
        container.classList.remove('active')
      } else {
        ;[...containers].forEach((wrapper) => {
          wrapper.classList.remove('active')
        })

        container.classList.add('active')
      }
    })
  })
}


// WEBPACK FOOTER //
// ./src/js/modules/FaqToggle.js